import { render, staticRenderFns } from "./PromotionalContent.vue?vue&type=template&id=51c8a1af&scoped=true"
import script from "./PromotionalContent.vue?vue&type=script&lang=js"
export * from "./PromotionalContent.vue?vue&type=script&lang=js"
import style0 from "./PromotionalContent.vue?vue&type=style&index=0&id=51c8a1af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8a1af",
  null
  
)

export default component.exports